import { render } from "./VehicleSelector.vue?vue&type=template&id=2ed7f8d2"
import script from "./VehicleSelector.vue?vue&type=script&lang=js"
export * from "./VehicleSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/mike/VueCode/service-package-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__